import React, { useState, useEffect } from 'react';

import CashInHand from './CashInHand/index';
import Receivable from './Receivable/index';
import Payable from './Payable/index';
import Summary from './Summary/index';

const home = props => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    console.log('count', count)
  }, [count]);

  return (
    <React.Fragment>
      <CashInHand count={count} setCount={setCount}/>
      <Receivable count={count} setCount={setCount}/>
      <Payable count={count} setCount={setCount}/>
      <Summary count={count} setCount={setCount}/>
    </React.Fragment>
  )
 
}

export default home;


// WEBPACK FOOTER //
// ./src/components/home.js